
import {
    SAVE_LEVEL_ONES_IMAGES
} from './types'

export const saveLevelOneImages = (payload) => dispatch => {
    dispatch({ type: SAVE_LEVEL_ONES_IMAGES,payload})
}